import { render, staticRenderFns } from "./UnitContent.vue?vue&type=template&id=3c7a40fc&scoped=true&"
import script from "./UnitContent.vue?vue&type=script&lang=js&"
export * from "./UnitContent.vue?vue&type=script&lang=js&"
import style0 from "./UnitContent.vue?vue&type=style&index=0&id=3c7a40fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7a40fc",
  null
  
)

export default component.exports